/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace CookieUtil
 */
class CookieUtil {
    constructor() {}
    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        if(exdays != 0){
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
        }
        $.cookie(cname,cvalue,{path: '/',expires: d});
    }

    getCookie(cname) {
        if(cname){
            if($.cookie(cname)){
                return $.cookie(cname);
            }else{
                return "";
            }
        }
    }

    deleteCookie(cname){
        $.removeCookie(cname, { path: '/' });
    }
}

export default new CookieUtil();
